<template title="选中条码">
  <div>
    <table style="width: 80%">
      <tr>
        <td>
          <table>
            <tr>
              <td>
                <div style="float: left">
                  <h1>{{ translateWords.title }}</h1>
                </div>
              </td>
            </tr>
            <tr>
              <td style="padding: 10px">
                <el-input v-model="keyword" :placeholder="translateWords.keyword"></el-input>
              </td>
              <td>
                <el-button type="primary" @click="query">{{
                  translateWords.query
                }}</el-button>
              </td>
              <td>
                <el-button type="primary" @click="OpenPL">{{
                  translateWords.batchInput
                }}</el-button>
              </td>
            </tr>
          </table>

          <div>
            <el-table ref="tableData" :data="tableData" style="width: 75%" :row-key="getRowKeys">
              <el-table-column type="selection" :reserve-selection="true" width="55" />
              <el-table-column v-if="false" prop="Goods_Id" label="Id" width="1">
              </el-table-column>
              <el-table-column prop="Goods_Name2" :label="translateWords.ProductName" width="200">
              </el-table-column>
              <el-table-column width="200" prop="BarCode" :label="translateWords.ProductCode">
              </el-table-column>
              <el-table-column width="200" prop="Goods_BigClass" :label="translateWords.ProductType"></el-table-column>
              <el-table-column width="200" prop="Goods_Code" :label="translateWords.GoodsCode"></el-table-column>
              <el-table-column width="200" prop="DesignedForName"
                :label="translateWords.DesignedForName"></el-table-column>
              <el-table-column width="200" prop="Goods_Size1" :label="translateWords.GoodsSize"></el-table-column>
              <el-table-column width="200" prop="Unit" :label="translateWords.Unit"></el-table-column>
              <el-table-column width="200" prop="ExpectedShipmentDateTime"
                :label="translateWords.ExpectedShipmentDateTime"></el-table-column>
              <el-table-column width="200" prop="ExpectedArrivalDateTime"
                :label="translateWords.ExpectedArrivalDateTime"></el-table-column>

              <el-table-column width="200" prop="IsBig" v-if="false"></el-table-column>
              <el-table-column width="200" prop="Status" v-if="false"></el-table-column>
              <el-table-column width="200" prop="ImgType" v-if="false"></el-table-column>
              <el-table-column width="200" prop="IsRequestByProductCenter" v-if="false"></el-table-column>
              <el-table-column width="200" prop="IsRequestByMultimedia" v-if="false"></el-table-column>
              <el-table-column width="200" prop="ExpectedShipmentDateTime" v-if="false"></el-table-column>
              <el-table-column width="200" prop="SumStorage" v-if="false"></el-table-column>
              <el-table-column width="200" prop="PositionId" v-if="false"></el-table-column>
              <el-table-column width="200" prop="RackId" v-if="false"></el-table-column>
            </el-table>
          </div>
        </td>
      </tr>
      <tr></tr>
      <tr>
        <td>
          <div style="float: left">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currPage"
              :page-sizes="[10, 20, 30]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
        </td>
      </tr>
      <tr>
        <td><el-button type="primary" @click="tijiao()">提交</el-button></td>
      </tr>
    </table>
  </div>
</template>

<script>
import { importScript } from "../util/importScript";

export default {
  name: "GetSampleFromAGBS",

  data() {
    return {
      translateWords: {
        title: "商品信息",
        keyword: "关键字",
        query: "查询",
        batchInput: "添加选中",
        ProductName: "商品名称",
        ProductCode: "商品条码",
        ProductType: "商品类别",
        GoodsCode: "商品编码",
        GoodsSize: "最小包装规格",
        Unit: "单位",
        IsBig: "是否大货样",
        ImgType: "图片类型",
        DesignedForName: "专供属性",
        IsRequestByProductCenter: "样品是否产品中心发起借用申请",
        IsRequestByMultimedia: "样品是否多媒体部自动发起借用申请",
        ExpectedShipmentDateTime: "预计出货时间",
        SumStorage: "入库数量",
        Position: "位置",
        Rack: "货架层",
        Status: "是否启用",
        selectData: "请选择数据",
        ExpectedShipmentDateTime: "预计出货日期",
        ExpectedArrivalDateTime: "预计到货日期",
      },
      keyword: "",
      tableData: [],
      total: 0,
      currPage: 1,
      pageSize: 10,
      uid: this.$route.query.uid,
      token: this.$route.query.token,
      lang: this.$route.query.lang
    };
  },
  created: function () {
    //this.getData(this.currPage, this.pageSize);
  },
  mounted() {
    var that = this;
    importScript(this.baseurl, () => {
      that.translateWord();
    });
  },
  methods: {
    translateWord() {
      var that = this;

      if (window.jsT) {
        this.translateWords = {
          title: window.jsT.T(that.translateWords.title),
          query: window.jsT.T(that.translateWords.query),
          batchInput: window.jsT.T(that.translateWords.batchInput),
          GoodsCode: window.jsT.T(that.translateWords.GoodsCode),
          ProductName: window.jsT.T(that.translateWords.ProductName),
          ProductCode: window.jsT.T(that.translateWords.ProductCode),
          ProductType: window.jsT.T(that.translateWords.ProductType),
          GoodsSize: window.jsT.T(that.translateWords.GoodsSize),
          Unit: window.jsT.T(that.translateWords.Unit),
          IsBig: window.jsT.T(that.translateWords.IsBig),
          ImgType: window.jsT.T(that.translateWords.ImgType),
          IsRequestByProductCenter: window.jsT.T(
            that.translateWords.IsRequestByProductCenter
          ),
          IsRequestByMultimedia: window.jsT.T(
            that.translateWords.IsRequestByMultimedia
          ),
          ExpectedShipmentDateTime: window.jsT.T(
            that.translateWords.ExpectedShipmentDateTime
          ),
          SumStorage: window.jsT.T(that.translateWords.SumStorage),
          Position: window.jsT.T(that.translateWords.Position),
          Rack: window.jsT.T(that.translateWords.Rack),
          Status: window.jsT.T(that.translateWords.Status),
          DesignedForName: window.jsT.T(that.translateWords.DesignedForName),
          selectData: window.jsT.T(that.translateWords.selectData),
          ExpectedShipmentDateTime: window.jsT.T(that.translateWords.ExpectedShipmentDateTime),
          ExpectedArrivalDateTime: window.jsT.T(that.translateWords.ExpectedArrivalDateTime),
        };
        console.log(this.translateWords);
      } else {
        console.log("翻译组件加载失败");
      }
    },
    OpenPL() {
      var _this = this;
      var selectRow = _this.$refs.tableData.selection;
      if (selectRow.length === 0) {
        alert(_this.translateWords.selectData);
      } else {
        this.$emit("loadtable", selectRow);
      }
    },
    tijiao() {
      var _this = this;
      var selectRow = _this.$refs.tableData.selection;
      if (selectRow.length === 0) {
        alert(_this.translateWords.selectData);
      } else {
        this.$emit("loadtable", selectRow);
      }
      this.$emit("closedialogAGBS");
    },

    getRowKeys(row) {
      return row.Goods_Id;
    },
    cleartable() {
      this.$refs.tableData.clearSelection();
    },
    query() {
      this.getData();
    },
    getData() {
      var _this = this;
      var params = {};
      params.PageIndex = _this.currPage;
      params.PageSize = _this.pageSize;
      params.KeyWord = _this.keyword;
      _this.$http
        .post(_this.baseurl + "/v1/api/Sample/GetSampleFromAGBS", params, {
          headers: { Authorization: _this.token }
        })
        .then(res => {
          // 情况1：当前页无数据且不在第一页
          if (res.data.List.length==0&& _this.currPage > 1) {
            //this.$message.warning('当前页无数据，已返回第一页');
            _this.currPage = 1;  // 自动重置为第一页
            return _this.getData();       // 重新查询
          }
          // 情况2：第一页也无数据
          if (res.data.List.length==0) {
            _this.tableData = [];
            _this.total = 0;
            return;
          }
          _this.tableData =  res.data.List;
          _this.total = res.data.totalCount;
        });
    },
    handleCurrentChange(val) {
      this.currPage = val;
      this.getData();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currPage = 1;
      this.getData();
    },

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/GetSampleFromAGBS.vue